/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Value } from './Value.js';
import {
    ValueFromJSON,
    ValueFromJSONTyped,
    ValueToJSON,
} from './Value.js';

/**
 * 
 * @export
 * @interface CustomerEntry
 */
export interface CustomerEntry {
    /**
     * 
     * @type {number}
     * @memberof CustomerEntry
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerEntry
     */
    customerId?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerEntry
     */
    contactId?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerEntry
     */
    fieldId?: number;
    /**
     * 
     * @type {Value}
     * @memberof CustomerEntry
     */
    value?: Value;
    /**
     * 
     * @type {number}
     * @memberof CustomerEntry
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerEntry
     */
    suggestionId?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerEntry
     */
    searchId?: number;
    /**
     * 
     * @type {Date}
     * @memberof CustomerEntry
     */
    dateCreated?: Date;
}

/**
 * Check if a given object implements the CustomerEntry interface.
 */
export function instanceOfCustomerEntry(value: object): boolean {
    return true;
}

export function CustomerEntryFromJSON(json: any): CustomerEntry {
    return CustomerEntryFromJSONTyped(json, false);
}

export function CustomerEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'contactId': json['contactId'] == null ? undefined : json['contactId'],
        'fieldId': json['fieldId'] == null ? undefined : json['fieldId'],
        'value': json['value'] == null ? undefined : ValueFromJSON(json['value']),
        'userId': json['userId'] == null ? undefined : json['userId'],
        'suggestionId': json['suggestionId'] == null ? undefined : json['suggestionId'],
        'searchId': json['searchId'] == null ? undefined : json['searchId'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
    };
}

export function CustomerEntryToJSON(value?: CustomerEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'customerId': value['customerId'],
        'contactId': value['contactId'],
        'fieldId': value['fieldId'],
        'value': ValueToJSON(value['value']),
        'userId': value['userId'],
        'suggestionId': value['suggestionId'],
        'searchId': value['searchId'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
    };
}

